"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "acquasparta": {
    "47f49ead": [{
      "hkey": "e8e7cf0e",
      "slug": "casteldelmonte",
      "name": "Casteldelmonte",
      "primary": true,
      "skipSearch": false
    }],
    "castel-del-monte": [{
      "hkey": "e8e7cf0e",
      "slug": "casteldelmonte",
      "name": "Casteldelmonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d19fe041": [{
      "hkey": "202894b7",
      "slug": "acquasparta",
      "name": "Acquasparta",
      "primary": true,
      "skipSearch": false
    }],
    "scoppio": [{
      "hkey": "202894b7",
      "slug": "acquasparta",
      "name": "Acquasparta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;